import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Chip } from '@mui/material';

import { makeStyles, useTheme } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  paymentMethodBox: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '420px',
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.shape.borderRadius,

    '&:hover': {
      borderColor: theme.palette.grey[500],
      backgroundColor: theme.palette.grey[100],
    },

    [theme.breakpoints.down('lg')]: {
      minWidth: '100%',
    },
  },
  cardIcon: {
    marginRight: theme.spacing(2),
    float: 'left',
  },
}));

const Props = {
  item: PropTypes.object,
  isDefault: PropTypes.bool,
  isExpired: PropTypes.bool,
};

const iconCard = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.666 5.3335H5.33268C3.85935 5.3335 2.67935 6.52683 2.67935 8.00016L2.66602 24.0002C2.66602 25.4735 3.85935 26.6668 5.33268 26.6668H26.666C28.1393 26.6668 29.3327 25.4735 29.3327 24.0002V8.00016C29.3327 6.52683 28.1393 5.3335 26.666 5.3335ZM26.666 24.0002H5.33268V16.0002H26.666V24.0002ZM26.666 10.6668H5.33268V8.00016H26.666V10.6668Z"
      fill="#212121"
    />
  </svg>
);

export default function PlanPaymentMethodCardBox({ item, isDefault, isExpired }) {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <>
      <Box className={classes.paymentMethodBox}>
        <Box className={classes.cardIcon}>{iconCard}</Box>

        <Box display="flex" flexDirection="column">
          <Typography>
            <b>
              {item.card.brand.toUpperCase()} ending in {item.card.last4}
            </b>
          </Typography>

          <Typography variant="body2">
            expires in {item.card.exp_month}/{item.card.exp_year} / {item.billing_details.name}
          </Typography>
        </Box>

        {isDefault && <Chip style={{ marginLeft: 'auto' }} label="Default" />}

        {isExpired && <Chip style={{ marginLeft: 'auto' }} label="Expired" color="secondary" />}
      </Box>
    </>
  );
}

PlanPaymentMethodCardBox.propTypes = Props;
